import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
$ = jQuery;



export function init(){
    
  
    
}

export function update(e){
    logoRotate(e);
    //parallax();
    if($("#home__intro").length){
        headerParallax(e);
    }
    if($("#home__resultaten").length){
        resultaten(e);
    }
    
    
}



export function logoRotate(e){
    var scrollTop = e.offset.y;
    var deg = scrollTop / 8;
    gsap.set($(".scroll-rotate-box"),
       {
            rotate:deg+"deg"
        }
    );

}

export function parallax(){


    /*var page = $("main").attr("page");
    if(page == "home"){
        
    }*/

    
    

}

export function resultaten(e){
    var scrollTop = e.offset.y;
    var resultsHtml = $(".result-box__container").html();
    $(".result").each(function (i, v) {
        var thisScrollTop = $(this).offset().top;
        //console.log(i);
        //alert(thisScrollTop);
        var thisHeight = $(this).outerHeight();
        var winH = $(window).outerHeight();
      

        if ((thisScrollTop + 20 < winH) && (thisScrollTop + thisHeight > 0)) {

            var relContHeight = thisHeight + winH;
            var c = thisScrollTop + thisHeight;
            var relPerc = ((1 - (c / relContHeight)) * 100) + 50;

            var thisH3Height = $(".inner", $(this)).outerHeight();

            //if ($(".result-inner:not(.visible)", $(this))) {
              //  $(".result-inner", $(this)).addClass("visible");
            //}
            $("h3", $(this)).css({
                "transform": "translate(0%, calc(-100% + " + ((relPerc * 0.7)) + "%))"
            });


        } else {
            //$(".result-inner", $(this)).removeClass("visible");
        }
        if ((thisScrollTop < (winH - 50)) && (thisScrollTop + thisHeight > 0)) {
            if ($(".video-box.show", $(this)).length == 0) {
                $(".video-box", $(this)).addClass("show");
                $("video", $(this)).attr({
                    "autoplay": "1"
                });
                $('video', $(this)).each(function () { // looks for all the html5 videos
                    this.currentTime = 0;
                    this.play();
                });
            }

        } else {
            if ($(".video-box.show", $(this)).length == 1) {
                $(".video-box", $(this)).removeClass("show");
                $('video', $(this)).each(function () { // looks for all the html5 videos
                    //this.currentTime = 0;
                    //this.pause();
                });
            }
        }

    });
    $(".readmore:not('.loaded')").each(function () {
        var thisScrollTop = $(this).offset().top;
        if (thisScrollTop < $(window).height()) {

            $(this).addClass("loaded");
            $("video", $(this)).attr({
                "autoplay": "1"
            });
            //infinate scroll 
            //$(".result-box__container").append(resultsHtml);
        }
    });
}

export function headerParallax(e) {

    var scrollTop = e.offset.y;
    //gsap.set($("#home__intro .text-overlay"), {y:scrollTop});
    var homeBottom = $("#home__intro").offset().top+($("#home__intro").height()-$(window).height());
    console.log(homeBottom);
    if (homeBottom < 0) {
        //console.log($("#home__intro").offset().top-scrollTop, homeBottom);
       
        //$("#home__intro .text-overlay").css({
            //"transform": "translate(-50%, calc(0vh - 50% + " + scrollTop + "px))"
        //});
        var perc = (scrollTop / $(window).height()) * 100;
        var layerMultiplier = $("#home__intro .text-overlay .h1").height() / ($(window).height() * 1) * 16;

       $(".h1 .layer-1").css({
            "top": "-" + scrollTop * 0.1 * layerMultiplier + "px"
        });
        $(".h1 .layer-2").css({
            "top": "-" + scrollTop * 0.2 * layerMultiplier + "px"
        });
        $(".h1 .layer-3").css({
            "top": "-" + scrollTop * 0.3 * layerMultiplier + "px"
        });
        $(".h1 .layer-4").css({
            "top": "-" + scrollTop * 0.4 * layerMultiplier + "px"
        });
        $(".h1 .layer-5").css({
            "top": "-" + scrollTop * 0.5 * layerMultiplier + "px"
        });
        $(".h1 .layer-6").css({
            "top": "-" + scrollTop * 0.6 * layerMultiplier + "px"
        });

        /*$("#home__resultaten").css({
            "transform": "translate(0, calc(-50vh + " + scrollTop2 * 0.5 + "px))"
        });*/
    }
}

export default {
    VALUE_1: 123,
    VALUE_2: "abc"
};